import './BadgeListItem.scss';

class BadgeListItem {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['BadgeListItem'] = BadgeListItem;
export default BadgeListItem;
